// Keep server bootId updated without forcibly logging out valid JWT sessions on routine restarts
export default function ServerRestartLogout() {
  return null;
}
